module.exports = {
  title: 'Animated Section List with Reanimated 📜',
  author: 'Enzo Manuel Mangano',
  date: '2023-06-02',
  slug: 'animated-indicator-list',
  tags: ['reanimated', 'gesture-handler'],
};
